import $ from "jquery";

export function removeFormErrors(form) {
    form.children().filter('.formerror').html("");
}


export function appendFormError(input) {
    var target = input.data('validation');
    var targets = target.split(',');
    for (var i = 0; i < targets.length; i++) {
        target = targets[ i ];
        var formError = $('#' + target);
        if (!formError.children().length) {
            formError.append("<span>" + input.get(0).validationMessage + "</span>");
        }
    }
}


// Updates the form errors for a given form ID
// using HTML 5 Validation
// each input requires a data-validation tag that holds
// the ID of the formerror div
export function updateFormErrors(formID) {
    var form = $('#' + formID);
    removeFormErrors(form);
    var children = form.children().children();
    children.filter('input,select').each(function () {
        if ($(this).get(0).validity.valid == false) {
            appendFormError($(this));
        }
    });
}
